module.exports = T;


//////////////////
// WEBPACK FOOTER
// external "T"
// module id = uezh
// module chunks = 191